import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateChoice } from "areas/product/store/actions"
import {
  ChoiceOption,
  OptionPrice,
  OptionsSlider,
} from "areas/product/wizard-options/components"
import Media from "components/ui/media"
import Select from "components/ui/select"
import { to_currency } from "helpers/number"
import { useNavigation } from "helpers/use-navigation"

const ChoiceOptions = ({ selectedValue, setChoice, data }) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <Media lessThan="tablet">
      <OptionsSlider
        aria-label={`${data.heading.title} Options`}
        data-slider="true"
        role="radiogroup"
      >
        {data.options.map((sc) => {
          const selected = selectedValue == sc.value
          return (
            <ChoiceOption
              aria-checked={selected}
              data-cy={`product-wizard-options-sc-${sc.value}`}
              data-filter={sc.filter}
              data-price={sc.price}
              data-sia={sc.sia}
              data-title={sc.value}
              data-value={sc.value}
              key={`sliderStoneOption-${sc.value}`}
              onClick={(e) => {
                setChoice(data.pref, sc, e)
              }}
              role="radio"
              tabIndex={selected ? 0 : -1}
              {...keyboardProps}
            >
              <div
                className="text-24 leading-40 text-center"
                style={{
                  minHeight: "40px",
                }}
              >
                {sc.value}
              </div>
              <OptionPrice>
                {sc.price > 0 ? "(+" + to_currency(sc.price) + ")" : ""}
              </OptionPrice>
            </ChoiceOption>
          )
        })}
      </OptionsSlider>
    </Media>
  )
}

ChoiceOptions.propTypes = {
  data: PropTypes.object,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
}

const InternalStoneCount = ({
  data,
  handleChange,
  selectedValue,
  setChoice,
}) => {
  if (!data) {
    return null
  }
  // console.log('selectedMetalFilter', selectedMetalFilter)
  return (
    <div>
      <Media
        greaterThanOrEqual="tablet"
        style={{ marginBottom: "1em", marginTop: "1em" }}
      >
        <Select
          className="border-grey-65 w-3/4 px-10 py-8 focus:outline-none"
          data-cy="product-wizard-sc-dropdown"
          data-pref="sc"
          onChange={(e) => {
            handleChange(data.pref, e)
          }}
          value={selectedValue}
        >
          {data.options.map((sc) => (
            <option
              data-display-image={sc.image}
              data-price={sc.price}
              data-sia={sc.sia}
              data-title={sc.value}
              data-value={sc.value}
              key={`stone-${sc.value}`}
              value={sc.value}
            >
              {sc.value} {sc.stone_count > 1 ? "Stones" : "Stone"}
              {sc.price > 0 ? "(+" + to_currency(sc.price) + ")" : ""}
            </option>
          ))}
        </Select>
      </Media>
      <FocusScope>
        <ChoiceOptions
          data={data}
          selectedValue={selectedValue}
          setChoice={setChoice}
        />
      </FocusScope>
    </div>
  )
}

InternalStoneCount.propTypes = {
  data: PropTypes.object,
  handleChange: PropTypes.func,
  resetVerge3D: PropTypes.func,
  selectedValue: PropTypes.func,
  setChoice: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    data: state.wizard.data.sc,
    selectedValue: state.choices.sc ? state.choices.sc.value || "" : "",
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch,
    setChoice: (pref, data) => {
      // console.log('size option clicked', e.target, $(e.target), $(e.target).is('*'))
      dispatch(updateChoice(pref, data, true))
    },
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { data } = stateProps
  const { dispatch } = dispatchProps

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    handleChange: (pref, e) => {
      // Find the object to send directly to updateChoice
      const val = e.target.value
      const sc = data.options.find((s) => s.value == val)
      try {
        dispatch(updateChoice(data.pref, sc, true))
      } catch (err) {
        console.log(err)
      }
    },
  }
}

InternalStoneCount.propTypes = {
  data: PropTypes.object,
  handleChange: PropTypes.func,
}

const StoneCount = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalStoneCount)

export default StoneCount
